/**
 * Reads the HubSpot user tracking cookie when running in the browser.
 */
export function getHubSpotTrackingCookie(): string | undefined {
  if (typeof document === 'undefined') return undefined;
  const match = document.cookie.match(/(^| )hubspotutk=([^;]+)/);
  return match?.[2];
}
